import { ISafetyTagBucket, SafetyTagsBucket } from '@lib/safety/safety';

export const ALL_EVENTS_BUCKET: ISafetyTagBucket[] = [{
  key: 'other' as SafetyTagsBucket,
  label: $localize`Others`,
  tooltip: null,
  tags: [
    'crash',
    'manual_event',
    'forward_collision_warning',
    'near_miss',
    'unsafe_parking',
    'zone_detection',
    'blind_spot_detection',
  ],
  color: null,
}];
